import i18n from "@breward/i18n";

export const CERTIFICATION_STEP_TYPES = {
  theory: {
    label: "global:shared.CertificationStepType.Theory",
  },
  practice: {
    label: "global:shared.CertificationStepType.Practice",
  },
};

export const JUDGE_APPLICATION_STATES = {
  submitted: {
    label: "global:shared.JudgeApplicationState.Submitted",
  },
  approved: {
    label: "global:shared.JudgeApplicationState.Approved",
  },
  rejected: {
    label: "global:shared.JudgeApplicationState.Rejected",
  },
  backup: {
    label: "global:shared.JudgeApplicationState.Backup",
  },
};
